export const culturalEvents = [
  {
    id: 'independence',
    name: 'Ghana Independence Day',
    date: 'March 6',
    month: 3,
    type: 'National',
    color: '#C9A558',
    icon: '🇬🇭',
    description: 'Ghana became the first sub-Saharan African country to gain independence from colonial rule on March 6, 1957 — under the visionary leadership of Kwame Nkrumah. The declaration echoed across the entire African continent, igniting independence movements everywhere.',
    significance: 'A watershed moment in Pan-African history. Nkrumah\'s declaration that "the independence of Ghana is meaningless unless it is linked up with the total liberation of Africa" gave voice to a continent.',
    howToMark: 'Wear Ghana\'s national colors — red, gold, green with the black star. Cook Ghanaian food. Read Kwame Nkrumah\'s independence speech. Share the story with your children.',
    learnMore: 'Research: Kwame Nkrumah, the Big Six, the United Gold Coast Convention (UGCC)',
  },
  {
    id: 'akwasidae',
    name: 'Akwasidae',
    date: 'Every 42 days (Sunday)',
    month: null,
    type: 'Royal Ceremony',
    color: '#C9A558',
    icon: '👑',
    description: 'The most sacred royal ceremony of the Ashanti Kingdom — held every 42 days on a Sunday. The Asantehene pays homage to the royal ancestors at the ancestral stools. Sacred drumming, libation, and ancestral communion take place at Manhyia Palace in Kumasi.',
    significance: 'Reaffirms the sacred bond between living royals and royal ancestors. The Golden Stool — which holds the soul of the entire Ashanti nation — is displayed. Ordinary citizens never sit on it.',
    howToMark: 'Pour libation for your own ancestors. Wear kente cloth. Research the Golden Stool and what it means for Akan identity. Reflect on which ancestors you are carrying forward.',
    learnMore: 'Research: The Golden Stool (Sika Dwa Kofi), Manhyia Palace, Osei Tutu I',
  },
  {
    id: 'homowo',
    name: 'Homowo',
    date: 'August — September',
    month: 8,
    type: 'Harvest Festival',
    color: '#5a9e6a',
    icon: '🌽',
    description: '"Homowo" means "hooting at hunger" — a harvest celebration by the Ga people of Greater Accra commemorating their ancestors\' survival of a devastating famine. Families reunite across generations, and the living pour the sacred palm nut soup (kpokpoi) as offering, inviting the dead to feast with them.',
    significance: 'During Homowo the dead literally return home. The living and the ancestors eat together. It is one of the most powerful expressions of ancestral communion in West Africa.',
    howToMark: 'Cook traditional Ga food — kpokpoi (palm nut soup with corn flour). Gather family. Pour libation at the door for those who have passed. Speak the names of your ancestors aloud.',
    learnMore: 'Research: The Ga people, Accra\'s history, kpokpoi recipe, ancestral communion',
  },
  {
    id: 'odwira',
    name: 'Odwira',
    date: 'September — October',
    month: 9,
    type: 'Purification Festival',
    color: '#8aaccf',
    icon: '🌊',
    description: 'The Akan festival of purification and renewal. "Odwira" means "to purify." Celebrated across all Akan communities to cleanse the community of spiritual impurities accumulated over the year, honour the ancestors, and give thanks for the harvest. It marks the Akan New Year.',
    significance: 'The entire community enters a sacred period of reflection. Past conflicts are resolved, relationships are healed, ancestral shrines are cleaned, and the community begins the new year in spiritual unity.',
    howToMark: 'Engage in personal reflection and genuine forgiveness. Settle long-standing disputes. Deep-clean your home. Cook food and leave a portion at the door for ancestors.',
    learnMore: 'Research: Akan New Year traditions, ancestral shrine practices, community reconciliation ceremonies',
  },
  {
    id: 'panafest',
    name: 'PANAFEST',
    date: 'July — August (biennial)',
    month: 7,
    type: 'Pan-African Festival',
    color: '#9b7fc8',
    icon: '✊',
    description: 'The Pan African Historical Theatre Festival — held in Cape Coast and Elmina, the heart of the Atlantic slave trade. PANAFEST unites Africans and diaspora from around the world for cultural performances, historical reflection, and deeply emotional healing ceremonies at the very dungeons where enslaved ancestors were held.',
    significance: 'A pilgrimage for the African diaspora to stand where their ancestors stood before the Middle Passage. Many experience profound healing and reconnection on this sacred ground.',
    howToMark: 'Research Cape Coast Castle and Elmina Castle. Watch documentaries about diaspora homecoming journeys to Ghana. Plan your own return. Understand the history of the door of no return.',
    learnMore: 'Research: Cape Coast Castle, Elmina Castle, the Middle Passage, Joseph DeGraft-Johnson',
  },
  {
    id: 'emancipation',
    name: 'African Emancipation Day',
    date: 'August 1',
    month: 8,
    type: 'Diaspora',
    color: '#C9A558',
    icon: '⛓️',
    description: 'Ghana was the first African country to make August 1st — the anniversary of the abolition of slavery in the British Empire (1834) — an official public holiday. Ghana uses this day to specifically honour the African diaspora and extend an open invitation for them to come home.',
    significance: 'A formal acknowledgement from the African continent that the diaspora belongs here. Ghana has said clearly: you were taken from us, and we want you back.',
    howToMark: 'Research the transatlantic slave trade and its legacy. Watch "Roots," "12 Years a Slave," or diaspora homecoming documentaries. Write a letter to an ancestor. Reflect on what freedom means today.',
    learnMore: 'Research: Joseph Jenkins Roberts, the abolition movement, Joseph Cinque, Frederick Douglass, Harriet Tubman',
  },
  {
    id: 'republic-day',
    name: 'Ghana Republic Day',
    date: 'July 1',
    month: 7,
    type: 'National',
    color: '#C9A558',
    icon: '🏛️',
    description: 'On July 1, 1960, Ghana became a republic — fully severing constitutional ties with Britain and establishing a Ghanaian head of state for the first time. Kwame Nkrumah became the first President of the Republic of Ghana, fulfilling the dream of total self-governance.',
    significance: 'Marks the completion of Ghana\'s journey to full self-governance. Nkrumah went on to champion the formation of the Organisation of African Unity (now the African Union).',
    howToMark: 'Read Nkrumah\'s "Africa Must Unite." Learn about the Pan-African movement. Explore how Ghana\'s independence directly inspired civil rights movements in the United States.',
    learnMore: 'Research: Kwame Nkrumah, Organisation of African Unity, Martin Luther King Jr\'s visit to Ghana\'s independence',
  },
  {
    id: 'aboakyir',
    name: 'Aboakyir (Deer Hunting Festival)',
    date: 'First Saturday of May',
    month: 5,
    type: 'Cultural Festival',
    color: '#b05060',
    icon: '🦌',
    description: 'The ancient Deer Hunting Festival of the Efutu people of Winneba, Ghana. Two warrior companies (Asafo) compete to catch a live deer barehanded as a sacred offering to the god Penkye Otu. The winner earns glory for their entire company. This 300-year-old tradition is still performed today.',
    significance: 'Demonstrates bravery, communal competition, and the living relationship between the Akan people and their gods. The deer represents divine sacrifice and favour.',
    howToMark: 'Watch video footage of this festival. Research the Efutu people and the town of Winneba. Reflect on the meaning of communal bravery in your own life.',
    learnMore: 'Research: Winneba Ghana, Efutu people, Asafo warrior companies, Penkye Otu deity',
  },
  {
    id: 'chale-wote',
    name: 'Chale Wote Street Art Festival',
    date: 'August (annual)',
    month: 8,
    type: 'Cultural Festival',
    color: '#e07020',
    icon: '🎨',
    description: 'Accra\'s annual street art and urban culture festival in Jamestown — one of Ghana\'s oldest neighborhoods, founded in the 17th century. "Chale Wote" means "Let\'s go" in Ga. The festival transforms the streets with murals, performance art, music, installations, and creative brilliance.',
    significance: 'Celebrates African creativity, the contemporary renaissance of Ghanaian culture, and the vibrant future that Africa is building. Jamestown itself was one of the earliest sites of British colonial presence.',
    howToMark: 'Follow Ghanaian and African artists on social media. Support African artists in your local community. Create something inspired by Ghanaian visual culture.',
    learnMore: 'Research: Accra Art Scene, Jamestown Accra, Ghanaian contemporary artists, Serge Attukwei Clottey',
  },
  {
    id: 'farmers-day',
    name: 'National Farmers Day',
    date: 'First Friday of December',
    month: 12,
    type: 'National',
    color: '#5a9e6a',
    icon: '🌾',
    description: 'Ghana\'s National Farmers Day honours the farmers and fisherfolk who feed the nation. The best farmers are publicly celebrated and awarded by the president. It is a day of national gratitude for those who work the land — deeply rooted in the Akan value of agricultural dignity.',
    significance: 'Reconnects modern Ghanaians with their agricultural roots. In the Akan worldview, farming is not just survival — it is a sacred act of co-creation with the earth.',
    howToMark: 'Cook a meal from scratch using African and Ghanaian ingredients. Research Ghanaian staple foods (fufu, waakye, kelewele, kontomire). Thank those who grow and prepare your food.',
    learnMore: 'Research: Ghanaian staple crops, cocoa farming history, palm oil production, Akan relationship with land',
  },
  {
    id: 'damba',
    name: 'Damba Festival',
    date: 'Third month of Islamic calendar (annual)',
    month: null,
    type: 'Cultural Festival',
    color: '#8aaccf',
    icon: '🌙',
    description: 'Damba is celebrated by the Northern Ghanaian peoples (Dagomba, Mamprusi, Gonja) to commemorate the birth of the Prophet Muhammad and also to honour the traditional chiefs. It combines Islamic reverence with deep traditional African celebration — a testament to Ghana\'s spiritual diversity.',
    significance: 'Demonstrates the peaceful coexistence of Islam and traditional African culture in Ghana\'s north, and the dignity of Northern Ghanaian heritage often overlooked in diaspora communities.',
    howToMark: 'Learn about the cultures of Northern Ghana. Research the Dagomba people, their drumming traditions, and their role in Ghana\'s diverse national identity.',
    learnMore: 'Research: Dagomba people, Tamale Ghana, Northern Ghana culture, Damba drumming',
  },
  {
    id: 'new-year-gh',
    name: 'New Year\'s Day',
    date: 'January 1',
    month: 1,
    type: 'National',
    color: '#C9A558',
    icon: '🎇',
    description: 'A nationwide public holiday marking the Gregorian new year. Families gather, churches hold watch-night services, and communities share hopes for the year ahead.',
    significance: 'A shared pause across Ghana\'s diverse peoples — a moment to reset intentions and honour continuity.',
    howToMark: 'Reflect on the year past. Set one heritage intention: learn a Twi phrase, cook one Ghanaian dish, or call an elder.',
    learnMore: 'Research: Ghana public holidays, watch-night traditions',
  },
  {
    id: 'constitution-day',
    name: 'Constitution Day',
    date: 'January 7',
    month: 1,
    type: 'National',
    color: '#8aaccf',
    icon: '📜',
    description: 'Commemorates the coming into force of the Fourth Republic Constitution on 7 January 1993 — the foundation of Ghana\'s modern democratic order after decades of instability.',
    significance: 'Celebrates constitutional democracy, the rule of law, and peaceful transitions of power.',
    howToMark: 'Read the preamble of Ghana\'s constitution. Discuss what democratic values mean in your household.',
    learnMore: 'Research: Fourth Republic Ghana, 1992 constitution referendum',
  },
  {
    id: 'may-day',
    name: 'May Day (Workers\' Day)',
    date: 'May 1',
    month: 5,
    type: 'National',
    color: '#b05060',
    icon: '⚙️',
    description: 'International Workers\' Day — a public holiday honouring labour, dignity of work, and trade union history across Ghana.',
    significance: 'Recognises farmers, teachers, health workers, artisans, and all who build the nation.',
    howToMark: 'Thank someone whose labour supports your life. Learn about Ghana\'s labour movement.',
    learnMore: 'Research: Ghana Trades Union Congress, May Day Accra',
  },
  {
    id: 'au-day',
    name: 'African Union Day',
    date: 'May 25',
    month: 5,
    type: 'National',
    color: '#006B3F',
    icon: '🌍',
    description: 'Marks the founding of the Organisation of African Unity (1963), now the African Union — a day of continental solidarity and Pan-African ideals.',
    significance: 'Connects Ghana\'s independence legacy to the broader project of African unity and self-determination.',
    howToMark: 'Read a speech by Kwame Nkrumah or a contemporary African leader. Follow AU heritage hashtags.',
    learnMore: 'Research: OAU founding, African Union, Pan-Africanism',
  },
  {
    id: 'founders-day',
    name: 'Founders\' Day',
    date: 'August 4',
    month: 8,
    type: 'National',
    color: '#C9A558',
    icon: '🕊️',
    description: 'A public holiday remembering the collective struggle for independence — the "Big Six" and all who campaigned for self-rule.',
    significance: 'Honours founders of the Ghanaian nation beyond any single figure.',
    howToMark: 'Learn one story of the UGCC, CPP, or the road to 1957. Share with younger relatives.',
    learnMore: 'Research: Big Six Ghana, UGCC, independence movement',
  },
  {
    id: 'nkrumah-memorial',
    name: 'Kwame Nkrumah Memorial Day',
    date: 'September 21',
    month: 9,
    type: 'National',
    color: '#CE1126',
    icon: '✊',
    description: 'Marks the birthday of Ghana\'s first president and a global Pan-African icon — Kwame Nkrumah (1909–1972).',
    significance: 'Celebrates Nkrumah\'s vision of independence linked to African liberation and unity.',
    howToMark: 'Read excerpts from "Africa Must Unite" or his independence speech. Visit online archives of Nkrumah legacy.',
    learnMore: 'Research: Kwame Nkrumah, Organisation of African Unity, Ghana Museum',
  },
  {
    id: 'christmas-gh',
    name: 'Christmas Day',
    date: 'December 25',
    month: 12,
    type: 'National',
    color: '#5a9e6a',
    icon: '🎄',
    description: 'A major public holiday across Ghana — church services, family meals, music, and community goodwill from Accra to Tamale.',
    significance: 'Blends Christian observance with Ghanaian hospitality and extended-family culture.',
    howToMark: 'Cook a Ghanaian holiday dish. Reach out to diaspora relatives. Give thanks.',
    learnMore: 'Research: Ghana Christmas traditions, Nine Lessons and Carols',
  },
  {
    id: 'boxing-day-gh',
    name: 'Boxing Day',
    date: 'December 26',
    month: 12,
    type: 'National',
    color: '#9b7fc8',
    icon: '🎁',
    description: 'A statutory public holiday in Ghana — a day for rest, visiting, charity, and festive leftovers.',
    significance: 'Extends communal celebration and informal gift-giving after Christmas.',
    howToMark: 'Rest. Visit neighbours or elders. Share surplus food or donate.',
    learnMore: 'Research: Boxing Day Commonwealth traditions',
  },
  {
    id: 'good-friday-gh',
    name: 'Good Friday',
    date: 'March–April (Friday before Easter)',
    month: null,
    type: 'National',
    color: '#6b5344',
    icon: '✝️',
    description: 'A Christian public holiday commemorating the crucifixion. Dates follow the Western ecclesiastical calendar (late March to April).',
    significance: 'Widely observed with church services, fasting, and reflection across Ghana.',
    howToMark: 'Attend or stream a Good Friday service. Reflect on sacrifice and renewal in your own journey.',
    learnMore: 'Research: Easter calendar, Ghana Christian Council',
  },
  {
    id: 'easter-monday-gh',
    name: 'Easter Monday',
    date: 'March–April (Monday after Easter Sunday)',
    month: null,
    type: 'National',
    color: '#C9A558',
    icon: '🌅',
    description: 'A public holiday immediately after Easter Sunday — family outings, beach visits, and continued celebration of resurrection themes.',
    significance: 'Extends Easter community gathering in a predominantly Christian cultural landscape.',
    howToMark: 'Spend time outdoors with family. Share a meal. Give thanks for renewal.',
    learnMore: 'Research: Easter traditions Ghana',
  },
  {
    id: 'eid-al-fitr-gh',
    name: 'Eid al-Fitr (End of Ramadan)',
    date: 'Islamic calendar — dates vary annually',
    month: null,
    type: 'National',
    color: '#1e4d8b',
    icon: '🌙',
    description: 'A statutory public holiday in Ghana marking the end of Ramadan — celebrated by Muslims with prayer, zakat, new clothes, and communal meals.',
    significance: 'Highlights Ghana\'s religious pluralism and the visibility of Islamic festivals nationwide.',
    howToMark: 'Greet Muslim friends with "Eid Mubarak." Learn how Ramadan builds discipline and compassion.',
    learnMore: 'Research: Eid al-Fitr Ghana, National Chief Imam',
  },
  {
    id: 'eid-al-adha-gh',
    name: 'Eid al-Adha (Feast of Sacrifice)',
    date: 'Islamic calendar — dates vary annually',
    month: null,
    type: 'National',
    color: '#8aaccf',
    icon: '🕌',
    description: 'A statutory public holiday commemorating Prophet Ibrahim\'s willingness to sacrifice — marked with congregational prayer and charitable meat distribution.',
    significance: 'Connects Ghana\'s Muslim communities to global ummah observances while reinforcing charity.',
    howToMark: 'Support local charity. Learn the story of Eid al-Adha with empathy and respect.',
    learnMore: 'Research: Eid al-Adha Ghana, Hajj symbolism',
  },
];

export const eventTypes = ['All', 'National', 'Royal Ceremony', 'Harvest Festival', 'Purification Festival', 'Pan-African Festival', 'Diaspora', 'Cultural Festival'];
